import Vue from 'vue' // 引入 Vue 是因为要用到 Vue.extend() 这个方法
// import Index from './NIndex.vue' // 引入刚才的 toast 组件
import LoginDialog from 'zjkj-login-dialog'
import loginDialog from './loginDialog.vue'

Vue.use(LoginDialog)

// let ToastConstructor = Vue.extend(Index) // 这个在前面的前置知识内容里面有讲到
let ToastConstructor = Vue.extend(loginDialog) 
let instance

const Login = function (options = {}) {
  instance = new ToastConstructor({
    data: options
  }).$mount() // 渲染组件
  // document.body.appendChild(instance.$el) // 挂载到 body 下
  document.body.appendChild(instance.$el)
}

export default Login
// Vue.extend(Main).$el
// Vue.extend(Main).$mount().$el
